import React, { useEffect, useRef, useState } from 'react'
import styles from './PersonaSetting.module.css'
import MainHeader from '../ReusableComponents/Header/MainHeader'
import { useHistory } from 'react-router'
import VerticalSlider from '../play/Remote/Klaw/Remote/component/KlawArmPlay/Verticalslider'
import VerticalSliderCard from './VerticalSliderCard'
import renderPrgImage from '../../source/programImg'
import { connect } from 'react-redux'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { appAiBytesGeneration } from '../AppMode/AppModeAI/AppModeAiBytesGeneration'

const PersonaSetting = (props) => {
    let history = useHistory()
    const [isShowConnectPopUp, setIsShowConnectPopUp] = useState(false)
    const [isShowUpload, setIsShowUpload] = useState({
        isShow: false,
        isUploaded: false,
        message: '',
    })
    const [tone, setTone] = useState('professional')
    const [sliderValues, setSliderValues] = useState({
        obedient: 100,
        mischievous: 100,
        cute: 100,
        stubborn: 100,
    })

    const sendDataAsPacket = useRef({
        byteSend: false,
        responseMessage: '',
    })

    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                sendDataAsPacket.current = {
                    byteSend: false,
                    responseMessage: '',
                }
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                // if (!sendDataAsPacket.current) {
                //     return resolve()
                // }
                if (!sendDataAsPacket.current.byteSend) {
                    return resolve(sendDataAsPacket.current.responseMessage)
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    const handelSliderChange = (slider, value) => {
        setSliderValues({ ...sliderValues, [slider]: value })
    }

    const onMouseUpHandel = () => {}

    //upload the person slider value
    const handelUploadBtnClick = async () => {
        if (!props.isConnected) {
            setIsShowConnectPopUp(true)
            return
        }

        setIsShowUpload({
            isShow: true,
            isUploaded: false,
            message: 'Persona uploading...',
        })
        try {
            let dataArr = Object.values(sliderValues).map(Number)
            let getStoTrainBytes = appAiBytesGeneration(
                'personaUpdateByte',
                dataArr
            )
            sendDataAsPacket.current = {
                byteSend: true,
                responseMessage: '',
            }
            props.worker.postMessage({
                type: 'WriteArrayFormat1310',
                value: getStoTrainBytes,
            })

            let replyOK = await Promise.race([
                checkOk(),
                timeoutPromise(1000), //
            ])

            setIsShowUpload({
                isShow: true,
                isUploaded: true,
                message: 'Persona uploaded.',
            })
        } catch (e) {
            console.error(e)
            setIsShowUpload({
                isShow: true,
                isUploaded: false,
                message: 'Persona upload failed, please try again!',
            })
        } finally {
            setTimeout(() => {
                setIsShowUpload({
                    isShow: false,
                    isUploaded: false,
                    message: '',
                })
            }, 2000)
        }
    }

    //read and write the persona data
    useEffect(() => {
        const fetchPersona = async () => {
            if (props.isConnected) {
                try {
                    let getStoTrainBytes = appAiBytesGeneration(
                        'personaUpdateByte',
                        []
                    )
                    sendDataAsPacket.current = {
                        byteSend: true,
                        responseMessage: '',
                    }
                    props.worker.postMessage({
                        type: 'WriteArrayFormat1310',
                        value: getStoTrainBytes,
                    })

                    let replyOK = await Promise.race([
                        checkOk(),
                        timeoutPromise(1000), //
                    ])

                    setSliderValues({
                        obedient: replyOK[4],
                        mischievous: replyOK[5],
                        cute: replyOK[6],
                        stubborn: replyOK[7],
                    })
                } catch (e) {
                    console.error(e)
                }
            }
        }
        fetchPersona()

        // const regexPattern = /^65,73,.*255,245$/
        // const fetchRegex = (num) =>
        //     new RegExp(
        //         `^65,76,\\d+,\\d+,${num},13,10,((?:\\d+,)*?)\\d+,255,245$`
        //     )

        const messageHandler = (e) => {
            if (e.data.type === 'actionRead') {
                let { arrayData, stringData } = e.data.value
                const pattern = /^65,73,.*255,245$/
                const isPatternMatch = pattern.test(arrayData.join(','))
                if (isPatternMatch) {
                    if (['S'.charCodeAt(0)].includes(arrayData[3])) {
                        sendDataAsPacket.current = {
                            byteSend: false,
                            responseMessage: arrayData,
                        }
                    }
                }
            }
        }

        props.worker.addEventListener('message', messageHandler)

        return () => {
            props.worker.removeEventListener('message', messageHandler)
        }
    }, [props.isConnected])

    return (
        <div className={styles.container}>
            <DialogModal
                show={isShowConnectPopUp}
                text={'Please connect the device.'}
                showCloseBtn={true}
                handleDialogModalClose={() => setIsShowConnectPopUp(false)}
            />

            <DialogModal
                show={isShowUpload.isShow}
                text={isShowUpload.message}
                showCloseBtn={false}
            />

            <MainHeader
                title={'Persona'}
                showBluetoothBtn={true}
                // helper={""}
                goBack={() => {
                    sessionStorage.setItem('slideDirection', true)
                    history.goBack()
                }}
            />

            {/* Persona Selection */}
            <div className={styles.field}>
                <div className={styles.controllerDiv}>
                    <VerticalSliderCard
                        sliderValues={sliderValues}
                        sliderType="obedient"
                        sliderLabel="Obedient"
                        handelSliderChange={handelSliderChange}
                        onMouseUpHandel={onMouseUpHandel}
                    />
                    <VerticalSliderCard
                        sliderValues={sliderValues}
                        sliderType="mischievous"
                        sliderLabel="Mischievous"
                        handelSliderChange={handelSliderChange}
                        onMouseUpHandel={onMouseUpHandel}
                    />
                    <VerticalSliderCard
                        sliderValues={sliderValues}
                        sliderType="cute"
                        sliderLabel="Cute"
                        handelSliderChange={handelSliderChange}
                        onMouseUpHandel={onMouseUpHandel}
                    />
                    <VerticalSliderCard
                        sliderValues={sliderValues}
                        sliderType="stubborn"
                        sliderLabel="Stubborn"
                        handelSliderChange={handelSliderChange}
                        onMouseUpHandel={onMouseUpHandel}
                    />
                </div>
            </div>

            {/* --------- footer ------------------------------- */}
            <p className={styles.footerText}>
                Use the sliders to adjust Zing's Persona
            </p>

            <img
                onClick={() => {
                    handelUploadBtnClick()
                }}
                // className="nextButton" //search for ".nextButton" in project directory to edit style
                id="uploadLogicscrn"
                src={renderPrgImage('uploadBtn')}
                style={{
                    position: 'absolute',
                    visibility: 'visible',
                    // top: '91%',
                    bottom: '2%',
                    right: '2%',
                    width: '60px',
                    // height: '60px',
                    cursor: 'pointer',
                    opacity: '1',
                }}
            ></img>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { isConnected: state.webSerial.isConnected, worker: state.worker }
}
export default connect(mapStateToProps)(PersonaSetting)
